import React from 'react';
import { Link } from 'react-router-dom';

const PageHeader = ({
  title,
  description,
  breadcrumbs = [],
  actions
}) => {
  return (
    <div className="admin-header d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4">
      <div className="mb-3 mb-md-0">
        {/* Breadcrumbs */}
        {breadcrumbs.length > 0 && (
          <nav aria-label="breadcrumb" className="mb-1">
            <ol className="breadcrumb mb-0 small">
              {breadcrumbs.map((crumb, index) => {
                const isLast = index === breadcrumbs.length - 1;
                return (
                  <li key={index} className={`breadcrumb-item ${isLast ? 'active' : ''}`}>
                    {!isLast && crumb.path ? (
                      <Link to={crumb.path} className="text-decoration-none text-muted">
                        {crumb.label}
                      </Link>
                    ) : (
                      <span className={isLast ? 'text-secondary' : 'text-muted'}>
                        {crumb.label}
                      </span>
                    )}
                  </li>
                );
              })}
            </ol>
          </nav>
        )}

        <h4 className="fw-bold text-dark mb-1">{title}</h4>
        {description && <p className="text-muted mb-0 small">{description}</p>}
      </div>

      {actions && (
        <div className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-2 mt-2 mt-md-0 w-100 w-md-auto">
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
